import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  const themeIcon = theme === 'dark' ? '☀️' : '🌙';
  const themeLabel = theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';

  return (
    <div className={`layout theme-${theme}`}>
      <nav className="navbar">
        <div className="navbar-center">
          <Link 
            to="/semana" 
            className={`nav-link ${location.pathname === '/semana' ? 'active' : ''}`}
          >
            Semana
          </Link>
          <Link 
            to="/mes" 
            className={`nav-link ${location.pathname === '/mes' ? 'active' : ''}`}
          >
            Mes
          </Link>
          <Link 
            to="/recetas" 
            className={`nav-link ${location.pathname === '/recetas' ? 'active' : ''}`}
          >
            Recetas
          </Link>
        </div>
        <button
          className="nav-theme-toggle"
          onClick={toggleTheme}
          aria-label={themeLabel}
          title={themeLabel}
        >
          {themeIcon}
        </button>
      </nav>
      <main className={`main-content ${location.pathname === '/semana' ? 'full-width' : ''}`}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
